export default "__VITE_ASSET__BIWApEiO__"